export const storeContestRecordOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '总经理',
      prop: 'gmName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运总监',
      prop: 'doName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运经理',
      prop: 'omName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运顾问',
      prop: 'ocName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '餐厅国际编号',
      prop: 'storeCode',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅名称',
      prop: 'storeName',
      editDisabled: true,
      width: '200px',
    },
    {
      label: '员工编号',
      prop: 'unionId',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '员工姓名',
      prop: 'nickName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '身份',
      prop: 'identity',
      editDisabled: true,
    },
    {
      label: '总分',
      prop: 'totalScore',
      editDisabled: true,
      width: '130px',
    },
    {
      label: '楼面技能得分',
      prop: 'basicScore',
      width: '120px',
      editDisabled: true,
    },
    {
      label: '综合能力得分',
      prop: 'additionalScore',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅排名',
      prop: 'rankInStore',
      editDisabled: true,
    },
    {
      label: '技能评分人',
      prop: 'basicJudgeName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '综合评分人',
      prop: 'additionalJudgeName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '录入时间',
      prop: 'judgeFinishedTime',
      editDisabled: true,
      width: '200px',
    },
  ]
}